<app-page>
    <app-title>{{ 'inactive_locations' | translate }}</app-title>
    <app-locations [locationsModel]="locationsModel"></app-locations>
</app-page>
